import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e211476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap nongfu-field-placeholder-wrap" }
const _hoisted_2 = { class: "tilte-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "购买时间说明", -1))
const _hoisted_4 = { class: "tips" }
const _hoisted_5 = { class: "tilte-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "凭证附图（发票/收据)", -1))
const _hoisted_7 = { class: "tips" }

import { Field } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { computed, reactive, ref } from 'vue'
import { CommonUploaderFileListItem } from '@/types/public'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair/index'
import AppHeader from '@/components/Header.vue'
import UploadImage from '@/components/upload/UploadImage.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'certificate-form',
  setup(__props) {

const max = 200
const imgMax = 3
const $route = useRoute()
const $router = useRouter()
const sn = $route.query.sn as string
const { malfunctionRepairState, setCertificateData } = useMalfunctionRepairStore()
const currentData = malfunctionRepairState.certificateDataSnMap[sn]
const form: {
  description: string
  files: CommonUploaderFileListItem[]
} = reactive({
  description: currentData?.description || '',
  files: currentData?.files?.map((item) => ({ ...item })) || [],
})
const desCount = computed(() => {
  return form.description.length
})
const imageLength = computed(() => {
  return form.files.length
})

function imageListChange(data: CommonUploaderFileListItem[]) {
  form.files = data.slice(0, 3)
}
function nextHandle() {
  setCertificateData({
    sn,
    item: {
      description: form.description,
      files: form.files,
    },
  })
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "购买凭证" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(desCount)) + "/" + _toDisplayString(max), 1)
        ]),
        _createVNode(_unref(Field), {
          rows: "3",
          type: "textarea",
          maxlength: max,
          class: "desc-textarea",
          modelValue: form.description,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.description) = $event)),
          placeholder: "请输入寄修各产品的购买日期并提供凭证，以便核实保修状态。"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(imageLength)) + "/" + _toDisplayString(imgMax), 1)
        ]),
        _createVNode(UploadImage, {
          style: {"margin-top":"12px"},
          onChange: imageListChange,
          defaultList: form.files,
          maxCount: 3
        }, null, 8, ["defaultList"])
      ])
    ]),
    _createVNode(CommonFooterNextButton, {
      onClick: nextHandle,
      title: "提交"
    })
  ], 64))
}
}

})